<template>
    <div class="search-company">
    <el-col :span="keywordSpan" :class="cls">
        <div class="form-group">
            <label v-if="showLabel">가~하, A~Z</label>
            <el-select class="keyword-select" v-model="keyword" placeholder="검색조건을 선택하세요." @change="changeKeyword" :disabled="disabled">
            <el-option
                v-for="item in keywordOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
            </el-select>
        </div>
    </el-col>
    <el-col :span="companySpan">
        <div class="form-group">
            <label v-if="showLabel">업체명</label>
            <el-select v-model="companySeq" filterable placeholder="업체를 선택하세요." @change="companySelected" v-on="$listeners" :disabled="disabled">
            <el-option
                v-for="item in companyList"
                :key="item.companySeq"
                :label="item.companyName"
                :value="item.companySeq">
            </el-option>
            </el-select>
        </div>
    </el-col>
    </div>
</template>

<script>
import CompanyProxy from '@/proxies/CompanyProxy'

export default {
    // inheritAttrs: false,
    name: 'search-company',
    props: {
        // 사용자계정이 있는 회사만 검색
        isUserCompany: {
            type: [Boolean],
            default: false
        },
        value : {
            type: [String, Number]
        },
        showLabel : {
            default: true
        },
        keywordSpan: {
            type: Number
        },
        companySpan: {
            type: Number
        },
        cls : {
            thpe: String
        },
        disabled: {
            default: false
        }

    },
    created() {
        if(this.value) {
            this.companySeq = this.value
        }    
        this.getAllCompanyList()
    },
    data() {
        return {
            keyword: '',
            companySeq: '',
            companyList: [],
            keywordOptions: [
                {label: '전체',value: ''},
                {label: '가',value: '가'},
                {label: '나',value: '나'},
                {label: '다',value: '다'},
                {label: '라',value: '라'},
                {label: '마',value: '마'},
                {label: '바',value: '바'},
                {label: '사',value: '사'},
                {label: '아',value: '아'},
                {label: '자',value: '자'},
                {label: '차',value: '차'},
                {label: '카',value: '카'},
                {label: '타',value: '타'},
                {label: '파',value: '파'},
                {label: '하',value: '하'},
                {label: 'A-z',value: 'a'}
            ],

        }
    },
    computed: {
        companyInfo() {
            const item = this.companyList.find(item => item.companySeq === this.companySeq)
            return (item || {})
        }
    },
    methods: {
        changeKeyword() {
            const param = {
                searchKey: this.keyword,
                isUserCompany: this.isUserCompany
            };
            new CompanyProxy(param)
            .findAdvertiserAll( )
            .then((response) => {
                this.companyList = response.company;
            })            
        },
        companySelected() {
            this.$emit('input', String(this.companySeq))
            this.$emit('selected', { ...this.companyInfo } )
        },
        getAllCompanyList() {
            new CompanyProxy({isUserCompany: this.isUserCompany})
            .findAdvertiserAll( )
            .then((response) => {
                this.companyList = response.company;
            })            
        },
        
    },
    watch: {
        value( val ) {
            if(String(this.companySeq) !== val) {
                this.companySeq = val
            }
            if(!this.companySeq) {
                this.keyword = '';
                this.getAllCompanyList()
            }
        }
    },



}    

</script>
<style>
    .search-company .keyword-select input { border-color: #DCDFE6 !important; }
</style>